import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'hidden h-fit justify-between gap-4 lg:flex',
    addToCart:
      'border-brand-400 [&>span]:text-brand-400 hover:bg-brand-400 px-[40px] hover:[&>span]:text-white'
  }
});
